module.exports = __webpack_public_path__ + "img/Lot2.4c18ae36.jpg";